import { SET_IS_AUTH, SET_AUTH } from '../constants';

export const isAuth = (isAuth = null, action) => (action.type === SET_IS_AUTH ? action.payload : isAuth);
export const auth = (auth = null, action) => (action.type === SET_AUTH ? action.payload : auth);
